import { Component, OnInit } from '@angular/core';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent} from'src/app/layout/layout.component';
@Component({
    selector: 'app-wmsm009',
    templateUrl: './wmsm009.component.html'
})
export class Wmsm009Component implements OnInit {
    index: number = 0;

    constructor(    private matomotracker:MatomoTracker,
        private LayoutComponent:LayoutComponent,
        ) { }

    ngOnInit() {
        this.LayoutComponent.geturl()
        this.matomotracker.trackPageView("一般性功能設置")
        this.matomotracker.trackEvent("一般性功能設置","代理設定","Transation",1);
    }

}
